export var CollectFun;
(function (CollectFun) {
    /**
     * Indicates, when returned from a collect function, to skip the value.
     */
    CollectFun.Skip = Symbol('Skip');
})(CollectFun || (CollectFun = {}));
//# sourceMappingURL=collect.mjs.map